import React, { Component } from 'react';
import {
  Button,
  Table,
  TableContainer,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  FormGroup,
  TextArea,
  TableToolbar,
  DataTableSkeleton,
} from 'carbon-components-react';
import { Link } from 'react-router-dom';
import { ArrowRight16, Checkmark24 } from '@carbon/icons-react';
import { Section } from '../../lib/react-scroll-section/src/index';
import { Menu, Item } from '../../helpers/scrolling/ScrollingMenuItem';
import '../../scss/custom.scss';
import { switchDateFormat } from '../../helpers/jsonschemaform/customwidget/utils';
import { showNotification } from '../../helpers/notification/BaseNotification';
import { getSuccess, getError, entitiesLabels, apioperation } from '../../helpers/Constants';
import { api } from '../../helpers/api/api';
import SimpleReactValidator from 'simple-react-validator';
import { NoRecordsPlaceholder } from '../../helpers/jsonschemaform/DataTableExtention';
import { IsEditable } from '../../helpers/authorization/Policies';
import { StatusTag } from '../../helpers/PageBreadCrumb';
const IncidentTabCausesModel = {
  id: null,
  investigationCriticalFactors: null,
  returnOfExperience: null,
  incidentCAR: [],
};

export default class IncidentTabCauses extends Component {
  initialState = (props) => {
    let initialState = {
      incidentModel: {
        ...IncidentTabCausesModel,
      },
      isDisabled: true,
    };
    if (props.incidentEditModel) {
      initialState.incidentModel = { ...props.incidentEditModel };
      initialState.isDisabled = !IsEditable(
        'Incident',
        'Reporting',
        props.user,
        props.incidentEditModel.status.id,
        'Causes',
        props.incidentEditModel
      );
    }
    return initialState;
  };

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.updateState = this.updateState.bind(this);

    this.state = {
      ...this.initialState(props),
    };
  }

  updateState = (inputName, inputValue, objName) => {
    let statusCopy = Object.assign({}, this.state);
    statusCopy[objName][inputName] = inputValue;

    this.setState(statusCopy);
  };

  selectTab = (index) => {
    this.props.selectTab(index);
  };

  saveTabCauses = () => {
    if (this.validator.allValid()) {
      this.props.isSubmitted(true);

      let datiForm = this.state.incidentModel;

      api
        .put('/incident/', datiForm, datiForm.id + '/causes')
        .then((response) => {
          if (response.status === 200) {
            showNotification.success(
              `${entitiesLabels.SUCCESS}`,
              this.state.incidentModel.id != null
                ? `${entitiesLabels.INCIDENT} ${entitiesLabels.WITHCODE} ${
                    datiForm.incidentReportId
                  } ${getSuccess('causes', apioperation.PUT)}`
                : getSuccess(entitiesLabels.INCIDENT, apioperation.POST)
            );
          } else {
            showNotification.error();
          }
        })
        .catch((error) => {
          showNotification.error(
            `${entitiesLabels.ERROR}`,
            getError(error, entitiesLabels.INCIDENT, apioperation.POST)
          );
        })
        .finally(() => {
          this.props.isSubmitted(false);
        });
      this.props.updateCacheIncidentModel(datiForm, 'tabCauses');
    } else {
      this.validator.showMessages();
      showNotification.warning(
        `${entitiesLabels.WARNING}`,
        entitiesLabels.INCIDENT + ' required fields are missing  '
      );
      this.forceUpdate();
    }
  };

  render() {
    const validations = {
      investigationCriticalFactors: this.validator.message(
        'investigationCriticalFactors',
        this.state.incidentModel.investigationCriticalFactors,
        'required'
      ),
    };
    if (!this.props.incidentEditModel || !this.props.incidentEditModel.id) {
      return null;
    }

    const rows = this.state.incidentModel.incidentCAR || [];

    return (
      <>
        <div className="bx--row">
          <div className="padding-progress-indicator-vertical hidden-box">
            <Menu>
              <Item section="investfind">3.1 Investigation Findings</Item>
              <Item section="carsection">3.2 ROOT CAUSES ANALISYS</Item>
            </Menu>
          </div>
          <div className="bx--col-lg-10 bx--col-md-10 margin-progress-indicator-vertical">
            <Section id="investfind" className="section--title">
              <div>
                <h3 className="title--medium--expressive">3.1 Investigation Findings (*)</h3>
                <h6>(It is forbidden to mention any Name and/or Surname. If necessary, use only the IP (Injured Person) wording and generic definition (such as witness, IP))</h6>
              </div>

              <div className="bx--row row-content section--title">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <FormGroup legendText="Detailed description of critical factors found during investigation*">
                    <TextArea
                      maxLength={5000}
                      id="investigationCriticalFactors"
                      placeholder="Input detailed description"
                      value={this.state.incidentModel.investigationCriticalFactors || ''}
                      onChange={(el) =>
                        this.updateState(
                          'investigationCriticalFactors',
                          el.target.value,
                          'incidentModel'
                        )
                      }
                      hideLabel={true}
                      labelText=""
                      light
                      rows={4}
                      cols={100}
                      invalid={validations.investigationCriticalFactors != null}
                      disabled={this.state.isDisabled}
                    />
                    {validations.investigationCriticalFactors}
                  </FormGroup>
                </div>
                <div className="bx--col-lg-12 bx--col-md-12">
                  <FormGroup legendText="REX (Return of Experience) proposal (​

It is forbidden to mention any Name and/or Surname. If necessary, use only the IP (Injured Person) wording and generic definition (such as witness, IP))" >
                    <TextArea
                      maxLength={5000}
                      id="returnOfExperience"
                      placeholder="Input REX (Return of Experience) proposal"
                      value={this.state.incidentModel.returnOfExperience || ''}
                      onChange={(el) =>
                          this.updateState('returnOfExperience', el.target.value, 'incidentModel')
                      }
                      hideLabel={true}
                      labelText=""
                      light
                      rows={4}
                      cols={100}
                      disabled={this.state.isDisabled}
                    />
                  </FormGroup>
                </div>
              </div>
            </Section>

            <Section id="carsection">
              <div>
                <h3 className="title--medium--expressive">3.2 ROOT CAUSES ANALISYS</h3>
              </div>
              <div className="bx--row">
                <div className="bx--col-lg-12 table-section-action">
                  <TableToolbar>
                    <h3 className="title--medium max-width"></h3>
                    <Link to={'/incident/' + this.props.incidentEditModel.id + '/car'}>
                      <Button 
                      renderIcon={ArrowRight16} 
                      className="table-toolbar-link-button" 
                      onClick={() => this.saveTabCauses()}
                      >
                        CAR Management
                      </Button>
                    </Link>
                  </TableToolbar>

                  <TableContainer className="bx--grid--full-width">
                    {this.props.isLoadingIncident ? (
                      <DataTableSkeleton headers={[]} rowCount={3} zebra={false} compact={false} />
                    ) : (
                      <Table>
                        <TableHead className="colorgray">
                          <TableRow>
                            <TableHeader>Owner Name</TableHeader>
                            <TableHeader>Owner Surname</TableHeader>
                            <TableHeader>CAR Code</TableHeader>
                            <TableHeader>Due Date</TableHeader>
                            <TableHeader className={'align-center'}>CAR Owner Involved</TableHeader>
                            <TableHeader>Status</TableHeader>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows == null || rows.length === 0 ? (
                            <NoRecordsPlaceholder labelText="No Records" colSpan={5} />
                          ) : (
                            rows.map((item, index) => (
                              <TableRow key={'row_' + item.id}>
                                <TableCell key={'cell_name_' + item.id}>
                                  {item.owner != null
                                    ? item.owner.name
                                    : item.ownerSaipem != null
                                    ? item.ownerSaipem.name
                                    : ''}
                                </TableCell>
                                <TableCell key={'cell_surname_' + item.id}>
                                  {item.owner != null
                                    ? item.owner.surname
                                    : item.ownerSaipem != null
                                    ? item.ownerSaipem.surname
                                    : ''}
                                </TableCell>
                                <TableCell key={'cell_carCode_' + item.id}>
                                  {item.incidentCARCode}
                                </TableCell>
                                <TableCell key={'cell_dueDate_' + item.id}>
                                  {' '}
                                  {switchDateFormat(item.dueDate, 'date')}
                                </TableCell>
                                <TableCell
                                  key={'cell_carOwnerInvolved_' + item.id}
                                  className={' align-center'}
                                >
                                  {this.state.incidentModel.idStatus > 2 ? (
                                    <Checkmark24 fill="#1A3E4C" aria-label="" />
                                  ) : (
                                    ''
                                  )}
                                </TableCell>
                                <TableCell key={'cell_status_' + item.id}>
                                  <StatusTag value={item.status && item.status.carManagementName} />
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    )}
                  </TableContainer>
                </div>
              </div>
            </Section>
          </div>
        </div>
        <div className="bx--row">
          <Button
            onClick={() => this.selectTab(1)}
            className="bx--col bx--btn--max-width"
            size="default"
            kind="secondary"
          >
            Prev Step
          </Button>
          <Button
            onClick={() => this.props.cancel()}
            className="bx--col bx--btn--max-width"
            size="default"
            kind="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={() => this.saveTabCauses()}
            disabled={this.state.isDisabled}
            className="bx--col bx--btn--max-width"
            size="default"
            kind="primary"
          >
            Save
          </Button>
          <Button
            onClick={() => window.print()}
            disabled={this.state.isDisabled}
            className="bx--col bx--btn--max-width"
            size="default"
            kind="secondary"
          >
            Print
          </Button>
          <Button
            onClick={() => this.selectTab(3)}
            className="bx--col bx--btn--max-width"
            size="default"
            kind="secondary"
          >
            Next Step
          </Button>
        </div>
      </>
    );
  }
}
